import React from "react";
import Card from "../../../UI/Card";

const Provide = () => {
  const provide = [
    {
      id: 1,
      num: "01",
      name: "Cross-border Payment",
      text: "Connect with the world effortlessly. Our Cross-Border Payment solution provides you with the tools to send and receive funds internationally.",
    },
    {
      id: 2,
      num: "02",
      name: "Connecting Business",
      text: "Our solution makes it easy for businesses, companies and other financial institutions to make global payment and receive with multiple currencies.",
    },
    {
      id: 3,
      num: "03",
      name: "Breaking Boundaries",
      text: "We break down the barriers hindering you from enjoying exemplary business and personal financial transactions.",
    },
    {
      id: 4,
      num: "04",
      name: "Trusted Financial Services",
      text: "Our commitment to being a Trusted Financial Service provider goes beyond transactions – it's about building a relationship founded on trust, security, and empowerment.",
    },
  ];
  return (
    <section className="xl:max-w-[83rem] pro:max-w-[52rem] max-w-[21.5rem] md:max-w-[45rem] lg:max-w-[60rem] mx-auto flex flex-col sm:flex-row pro:justify-around sm:justify-evenly">
      <div className="flex flex-col justify-center pt-[0.5rem] ">
        <h1 className="uppercase text-[#017A59] text-sm lg:text-base xl:text-[1.5rem] md:text-base pt-[3.13rem] sm:pt-[6.25rem] font-semibold leading-[2.3125rem] tracking-[-0.03rem]">
          What we provide
        </h1>

        <p className="sm:text-[#1D1D1F] text-[#8A9099] md:w-44 lg:w-full pt-[0.63rem] sm:pt-[2rem] text-base md:text-[13px] lg:text-base xl:text-[1.5rem] font-medium leading-normal lg:leading-[2.3125rem] tracking-[-0.03rem]">
          We are here to offer you <br className="hidden sm:block" />
          topnotch payment and business <br className="hidden sm:block" />
          services you will not find <br className="hidden sm:block" />
          anywhere else.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-[1.88rem] pt-[3.32rem] sm:pt-[12.06rem] lg:pb-[4rem] xl:pb-[7rem] mx-auto sm:mx-0 sm:place-content-start sm:justify-start text-start items-start">
        {provide.map((item) => (
          <Card
            key={item.id}
            className="xl:w-[23.3125rem] lg:w-[19.3125rem] w-[21.375rem] h-[14.9875rem] md:w-[15.3125rem] md:h-[16.5125rem] lg:h-[16.9125rem] xl:h-[18.8125rem] relative bg-[#EBFFF5] bg-opacity-40  rounded-xl shadow-md md:p-[0.85rem] p-[0.8rem] lg:p-[1.22rem] xl:p-[1.82rem]"
          >
            {" "}
            <p className="text-[#017A59] text-opacity-40 text-[1.375rem] md:text-2xl lg:text-[2.375rem] xl:text-[2.875rem] font-bold leading-[3.875rem] tracking-[-0.0575rem]">
              {item.num}
            </p>
            <h1 className="md:pb-[0.75rem] text-[1.125rem] pb-[0.75rem] lg:pb-[1rem] text-[#017A59] md:pt-[0.85rem] lg:pt-[1rem] xl:pt-[1.5rem] lg:text-base xl:text-[1.375rem] font-semibold leading-normal sm:leading-[2rem] ">
              {item.name}
            </h1>
            <p className="text-[#1D1D1F] text-sm lg:text-[0.9rem] md:text-[0.8rem] xl:text-[1.125rem] font-medium leading-[1.5rem]">
              {item.text}
            </p>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Provide;
